// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__wwpX6","hidden":"Pagination_hidden__utXwp","page":"Pagination_page__Dt7PP","active":"Pagination_active__saCmD"};